 <!--
  2019-3-7, AJK, created file
 -->


<template>
</template>

<script>
export default {
  name: 'toast',
  data () {
    return {
    }
  },
  methods: {  
    error: function(msg, title){
        this.$snotify.error( msg, title,
          {
            showProgressBar: false,
            position: 'rightBottom',
            icon: false,
            timeout: 4000,
            closeOnClick: true,
            bodyMaxLength: 1000
          }
        )
    },
    success: function(msg, title){
      this.$snotify.success( msg, title,
        {
          showProgressBar: false,
          position: 'rightBottom',
          icon: false,
          timeout: 4000,
          closeOnClick: true,
          bodyMaxLength: 1000
        }
      )
    }
  }
}
</script>